import React from 'react'
import PropTypes from 'prop-types'

export interface TiledListLineItemProps {
  fullWidth?: boolean
  children: React.ReactNode
}

const TiledListLineItem = ({ fullWidth = false, children }: TiledListLineItemProps): React.ReactElement => {
  const gridWidth = fullWidth ? 'medium-12' : 'medium-4'
  const cssClasses = `cell small-12 ${gridWidth} recent-post-list-item`

  return (
    <li className={cssClasses}>
      {children}
    </li>
  )
}

TiledListLineItem.propTypes = {
  fullWidth: PropTypes.bool,
  children: PropTypes.node.isRequired
}

export default TiledListLineItem
